import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Portfolio } from './pages/Portfolio';
import { Services } from './pages/Services';
import { Testimonials } from './pages/Testimonials';
import { StoreInfo } from './pages/StoreInfo';
import { Contact } from './pages/Contact';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<About data-id="element-5" />} data-id="element-4" />
        <Route path="/portfolio" element={<Portfolio data-id="element-7" />} data-id="element-6" />
        <Route path="/services" element={<Services data-id="element-9" />} data-id="element-8" />
        <Route path="/testimonials" element={<Testimonials data-id="element-11" />} data-id="element-10" />
        <Route path="/store-info" element={<StoreInfo data-id="element-13" />} data-id="element-12" />
        <Route path="/contact" element={<Contact data-id="element-15" />} data-id="element-14" />
      </Routes>
    </Router>;
}